import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import project1 from "../images/video.png"
import project2 from "../images/movie.png";
import project3 from "../images/attendance.jpeg";
import project4 from "../images/mern-stack.jpg";
import project5 from "../images/speech.jpeg";
import project6 from "../images/flutter.png";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    background: "#233",
    height: "100%",
  },
  cardContainer: {
    maxWidth: 345,
    margin: "3rem auto",
  },
}));

const projects = [
  {
    name: "Connector",
    title: "Blogging Website",
    description: `Developed an online Blogging website.It is JWT Authenticated , website where user can post their blogs or an article.\
    It's a Mern Stack Project, where user can upload share their personal and professional Vlogs`,
    image: project4,
  },
  {
    name: "LAKE Dataset",
    title: "Major Project",
    description: `Develop an indigenous speech command dataset for audio analysis.\
    Lake Dataset (Location Attached Keyword and Emotion Dataset) an audio dataset having multiple keywords with diverse emotions with back-
    ground noise infused with it, which is being collected at distinctive location.\
    Try developing a dataset robust to background noise and helps in physical environment classification.`,
    image: project5,
  },
  {
    name: "Smart Attendance System",
    title:"Minor Project",
    description: `Idea behind the project is to include diverse strategies to mark attendance in much less than three seconds.\
    Smartphones have diverse sensors consisting of camera, microphone and a fingerprint sensor that can be used to affirm man or woman with
    quite high accuracy and quite quick.\
    Location verification can be completed using beacons.\
    User verification is mainly focused on three different tasks Speaker Verification using audio, Face Verification using Images and Fingerprint
    Sensor`,
    image: project3,
  },
  {
    name: "Wireless Video Transmission",
    title:"Reaserch Project",
    description: `Designed an optimum system for wireless video streaming by using 2 Raspberry pi b+ model.\
    Transmission of data is based on SPI(Serial Peripheral Interface) Protocol.\
    Developed a Python script for encoding and decoding of frames for the transmission of Data.`,
    image: project1,
  },
  {
    name: "Visual Speech Recognition",
    title: "Mini Project",
    description: `End to End Sentence-level Lip Reading for the given input video.\
    Use of Lipnet model to map variable length sequence of video with text.`,
    image: project5,
  },
  {
    name: "Movie Review System",
    title:"Summer Internship",
    description: `Sentiment Analysis for Movie Reviews.\
    Worked on the dataset taken from Rotten Tomatoes.\
    Classified the dataset into 5 labels.\
    Achieved an accuracy of 68% with overall 15th rank on Kaggle.`,
    image: project2,
  },
  {
    name: "NoteKeeper Android App",
    title: "Flutter App",
    description: `Developed an Andriod App using Flutter.\
    The App is based on SQLite Database System and can be used by user\
    for keeping small notes and information in app.`,
    image: project6,
  }
];

const Portfolio = () => {
  const classes = useStyles();
  return (
    <Box component="div" className={classes.mainContainer}>
      <Grid container justify="center">
        {/* Projects */}
        {projects.map((project, i) => (
          <Grid item xs={12} sm={8} md={4} key={i}>
            <Card className={classes.cardContainer}>
              <CardActionArea>
                <CardMedia
                  component="img"
                  alt="Project 1"
                  height="140"
                  image={project.image}
                />
                <CardContent>
                  <Typography variant="h5" gutterBottom>
                    {project.name}
                  </Typography>
                  <Typography varient="subtitile2" gutterBottom >
                    {project.title}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {project.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
              <CardActions>
                <Button size="small" color="primary">
                  Share
                </Button>
                <Button size="small" color="primary">
                  Visit
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Portfolio;
